import React from "react";

const TemarioPosgradoPsiquiatriaClinica = () => {
    return (
        <div className="temario-container border w-100 p-5">
            <b>{"Fundamentos y definiciones en urgencias psiquiátricas"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Conceptos básicos y definiciones"}</span></li>
                <li><span className="fw-light">{"Epidemiología y estadísticas de urgencias psiquiátricas"}</span></li>
                <li><span className="fw-light">{"Marco legal y ético en urgencias psiquiátricas"}</span></li>
            </ul>
            <br /><br />
            <b>{"Evaluación y manejo inicial en urgencias psiquiátricas"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Principios de evaluación y manejo inicial"}</span></li>
                <li><span className="fw-light">{"Evaluación y manejo de casos clínicos complejos"}</span></li>
                <li><span className="fw-light">{"Simulación de urgencias psiquiátricas"}</span></li>
            </ul>
            <br /><br />
            <b>{"Trastornos psicóticos"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Psicosis aguda"}</span></li>
                <li><span className="fw-light">{"Trastornos psicóticos"}</span></li>
                <li><span className="fw-light">{"Manejo de la agitación y la agresividad"}</span></li>
            </ul>
            <br /><br />
            <b>{"Depresión, riesgo suicida y trastornos del estado de ánimo"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Depresión y riesgo suicida"}</span></li>
                <li><span className="fw-light">{"Trastornos del estado de ánimo"}</span></li>
                <li><span className="fw-light">{"Tratamiento de la depresión y el riesgo suicida"}</span></li>
            </ul>
            <br /><br />
            <b>{"Trastorno bipolar"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Trastorno bipolar en fase aguda"}</span></li>
                <li><span className="fw-light">{"Tratamiento del trastorno bipolar en fase aguda"}</span></li>
            </ul>
            <br /><br />
            <b>{"Trastornos de ansiedad y estrés"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Trastornos de ansiedad y pánico"}</span></li>
                <li><span className="fw-light">{"Trastornos de estrés postraumático"}</span></li>
                <li><span className="fw-light">{"Tratamiento de los trastornos de ansiedad y pánico"}</span></li>
            </ul>
            <br /><br />
            <b>{"Trastornos de personalidad"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Trastornos de la personalidad"}</span></li>
                <li><span className="fw-light">{"Urgencias psiquiátricas en personas con trastornos de la personalidad"}</span></li>
            </ul>
            <br /><br />
            <b>{"Tratamientos y terapias"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Farmacología"}</span></li>
                <li><span className="fw-light">{"Terapias psicológicas"}</span></li>
                <li><span className="fw-light">{"Intervenciones de crisis y resolución de conflictos"}</span></li>
            </ul>
            <br /><br />
            <b>{"Urgencias psiquiátricas en poblaciones específicas"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Urgencias psiquiátricas en niños y adolescentes"}</span></li>
                <li><span className="fw-light">{"Urgencias psiquiátricas en adultos mayores"}</span></li>
                <li><span className="fw-light">{"Urgencias psiquiátricas en personas con discapacidad"}</span></li>
                <li><span className="fw-light">{"Urgencias psiquiátricas en personas con trastornos del desarrollo"}</span></li>
            </ul>
            <br /><br />
            <b>{"Urgencias psiquiátricas y comorbilidades médicas"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Urgencias psiquiátricas en personas con enfermedades médicas crónicas"}</span></li>
                <li><span className="fw-light">{"Coordinación con servicios de emergencia y hospitalización"}</span></li>
            </ul>
            <br /><br />
            <b>{"Aspectos legales y éticos"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Aspectos legales en psiquiatría"}</span></li>
                <li><span className="fw-light">{"Discusión de casos clínicos y resolución de problemas con y sin implicancia legal"}</span></li>
                <li><span className="fw-light">{"Documentación y registro"}</span></li>
            </ul>
            <br /><br />
            <b>{"Análisis de casos, errores y complicaciones"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Análisis de errores y complicaciones en urgencias psiquiátricas"}</span></li>
                <li><span className="fw-light">{"Comunicación efectiva con pacientes y familias"}</span></li>
                <li><span className="fw-light">{"Revisión y evaluación final del programa"}</span></li>
            </ul>
        </div>
    );
};

export default TemarioPosgradoPsiquiatriaClinica;
